import { Button } from '@mui/material';

const CustomButton = ({
  text = 'Click Me',
  color = '#121212',
  hoverColor = '#d5d5d5',
  textColor = 'white',
  hoverTextColor = '#000',
  width = '100%',
  borderRadius = 2,
  padding = '16px',
  fontSize = '1.1rem',
  fontWeight = 600,
  textTransform = 'none',
  boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)',
  hoverBoxShadow = '0 6px 18px rgba(0, 0, 0, 0.2)',
  enableHoverScale = true,
  scaleAmount = 1.03,
  transitionDuration = '0.3s',
  disabled = false,
  onClick,
  type = 'button',
  fullWidth = false,
  variant = 'contained',
  ...props
}) => {
  const buttonStyles = {
    backgroundColor: color,
    color: textColor,
    borderRadius: borderRadius,
    py: padding,
    fontSize: fontSize,
    fontWeight: fontWeight,
    textTransform: textTransform,
    boxShadow: boxShadow,
    width: fullWidth ? '100%' : width,
    minWidth: fullWidth ? 'auto' : width,
    transition: `all ${transitionDuration} ease`,
    '&:hover': {
      backgroundColor: hoverColor,
      color: hoverTextColor,
      transform: enableHoverScale ? `scale(${scaleAmount})` : 'none',
      boxShadow: hoverBoxShadow,
    },
    '&:disabled': {
      backgroundColor: '#cccccc',
      color: '#666666',
      transform: 'none',
      boxShadow: 'none',
    },
    // Mobile responsive adjustments
    '@media (max-width: 600px)': {
      fontSize: '1rem',
      py: '14px',
      transform: 'none', // Disable scaling on mobile for better UX
      '&:hover': {
        transform: 'none',
      },
    },
  };

  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      sx={buttonStyles}
      {...props}
    >
      {text}
    </Button>
  );
};

export default CustomButton; 